import { useEffect, useState } from "react";
import sdk from "@farcaster/miniapp-sdk";

/**
 * Hook to detect if the app is running in a Farcaster Mini App context.
 *
 * WEB VERSION: Uses the Farcaster SDK to check if running in Mini App.
 *
 * This hook caches the result to avoid repeated async calls to the SDK.
 * The SDK check runs once on mount and the result is stable across re-renders.
 *
 * @returns {Object} Object containing:
 *   - isInMiniApp: boolean | null - true if in Farcaster Mini App, false if not, null if still checking
 *   - isLoading: boolean - true while the SDK check is in progress
 */
export const useFarcasterContext = () => {
  const [isInMiniApp, setIsInMiniApp] = useState<boolean | null>(null);

  useEffect(() => {
    sdk
      .isInMiniApp()
      .then((inMiniApp) => {
        setIsInMiniApp(inMiniApp);
      })
      .catch((error: any) => {
        console.log("Farcaster SDK check failed:", error);
        // If SDK check fails, assume not in Mini App
        setIsInMiniApp(false);
      });
  }, []);

  return {
    isInMiniApp,
    isLoading: isInMiniApp === null,
  };
};
